import { AccessLevels } from 'src/app/types/access-levels';

export class ActionsFormatter {
	static Format(row, cell, value, columnDef, dataContext) {
		let html = '<button type="button" class="btn btn-primary" data-role="zoom-to" data-gid="' + value + '">';
		html += '<span class="fas fa-crosshairs" title="zoom to feature"></span>';
		html += '</button>';
		if (columnDef.params.access > AccessLevels.READ) {
			html += '<button type="button" class="btn btn-primary stateful req-edit" data-role="feature-edit" data-gid="' + value + '">';
			html += '<span class="fas fa-draw-polygon" title="edit feature geometry"></span>';
			html += '</button>';
		}
		html += '<button type="button" class="btn btn-primary" data-role="view-attributes" data-gid="' + value + '">';
		html += '<span class="fas fa-info" title="view feature values"></span>';
		html += '</button>';
		html += '<button type="button" class="btn btn-primary" data-role="query-by-feature" data-gid="' + value + '">';
		html += '<span class="fas fa-hand-point-up bufferable" title="Find features in all layers using this feature\'s geometry"></span>';
		html += '</button>';
		html += '<button type="button" class="btn btn-primary stateful req-viewer"  title="Find features in all visible layers using this feature\'s geometry" data-role="query-by-feature-vis" data-gid="' + value + '">';
		html += '<span class="fas fa-hand-point-up bufferable"></span>';
		html += '<span class="fas fa-eye sub-icon"></span>';
		html += '</button>';
    html += '<button type="button" class="btn btn-danger" data-role="drop-result" data-gid="' + value + '">';
		html += '<span class="fas fa-trash" title="Remove this entry from these results"></span>';
		html += '</button>';

		return html;
	}
	static FormatGeomActions(row,cell,value,columnDef,dataContext) {
		return '';
	}
}
